import { createContext, useContext } from "react";
/** @todo: Integrate into `ClientContext` */ export var MetaInformationContext = createContext(undefined);
export var useMetaInformationProps = function() {
    var context = useContext(MetaInformationContext);
    if (context === undefined) {
        throw new Error("useMetaIntormationProps must be used within a MetaInformationContext.Provider");
    }
    return context;
};
